import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token: string, exp = false) {
  return Cookies.set(TokenKey, token, { expires: exp ? 30 : undefined })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
